export default __webpack_public_path__ + "static/media/truewallet.2f48a29a.png";